import React, { useEffect, useState, useMemo } from 'react';
import Moment from 'react-moment';
import { useNavigate } from 'react-router-dom';
import 'moment-timezone';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';

import { numeroSegonsEntreDates, convertirMilisMinuts, convertirMilisHores, numeroSegonsEntreDates2 } from '../../Helpers/funcionsDates';
import { useDispatch, useSelector } from 'react-redux';
import { esborrarErrorAction, uiAmagarIncidenciesAction, uiMostraDiaConsultatAction } from '../../actions/ui';

// ARQUITECTURA NOVA: llegeix incidències de cp.detallSetmana.llistatIncidencies
// en lloc de cp.llistatIncidenciesSetmana
//
// CORRECCIONS respecte l'original:
// 1. Les incidències es llegeixen de detallSetmana (dades ja carregades, no cal crida extra)
// 2. useSelector agafava tot el state -> ara selectiu

export const ContadorJornadaHoresSetmana = ({ diaAmbFixatges, hores }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { configUsuari, cp, ui } = useSelector(state => ({
        configUsuari: state.configUsuari,
        cp: state.cp,
        ui: state.ui
    }));
    const { t } = useTranslation('generic');
    const { incidencia } = ui;
    const { contingut } = configUsuari || {};

    const [contadorJornadaIniciada, setContadorJornadaIniciada] = useState(new Date());

    // Interval fix (deps buit -> creat una sola vegada per instància)
    useEffect(() => {
        const interval = setInterval(() => setContadorJornadaIniciada(new Date()), 10000);
        return () => clearInterval(interval);
    }, []);

    const { horesTreballades, minutsTreballats, diaAvui, diaAmbIncidencia, tipusDia } = useMemo(() => {
        let segonsTotalDia = 0;
        let sumaMinuts = 0;
        let diaAvuiLocal = false;
        let diaAmbIncidenciaLocal = false;
        let tipusDiaLocal = 'Laborable';

        if (!diaAmbFixatges || !configUsuari) {
            return { horesTreballades: 0, minutsTreballats: 0, diaAvui: false, diaAmbIncidencia: false, tipusDia: 'Laborable' };
        }

        const dataAvui = new Date();
        const dateDia = new Date(diaAmbFixatges.dia);
        const dayOfWeek = dateDia.getDay();
        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

        if (isWeekend) tipusDiaLocal = dayOfWeek === 6 ? 'Dissabte' : 'Finde';
        if (contingut.llistatFestius.diesFestius.some(e => e.dataFestiu === diaAmbFixatges.dia)) tipusDiaLocal = 'Festiu';
        if (contingut.llistatVacances.diesVacances.some(e => e.dataVacances === diaAmbFixatges.dia)) tipusDiaLocal = 'Vacances';

        const borsaHoresDia = contingut.llistatDiesBorsaHores.diesBorsa.find(
            e => e.dataBorsa === diaAmbFixatges.dia && e.estat === '1'
        );
        if (borsaHoresDia) {
            tipusDiaLocal = 'Borsa hores';
            sumaMinuts = borsaHoresDia.minutsDemanats;
        }

        // ── Fixatges del dia ─────────────────────────────────────────────────
        diaAmbFixatges.fixatges.forEach((d, index) => {
            if (['1', '2'].includes(d.IdTipus_Fixatge)) {
                const nextFixatge = diaAmbFixatges.fixatges[index + 1];
                if (!nextFixatge) {
                    const dataDiaRebut = new Date(diaAmbFixatges.dia);
                    dataDiaRebut.setHours(0, 0, 0, 0);
                    if (dataAvui.setHours(0, 0, 0, 0) !== dataDiaRebut.getTime()) diaAmbIncidenciaLocal = true;
                    else diaAvuiLocal = true;

                    if (moment(d.DataHora_Fixatge).format('YYYY-MM-DD') === moment(dataAvui).format('YYYY-MM-DD')) {
                        segonsTotalDia += numeroSegonsEntreDates2(d.DataHora_Fixatge, contadorJornadaIniciada);
                    }
                } else {
                    segonsTotalDia += numeroSegonsEntreDates(d.DataHora_Fixatge, nextFixatge.DataHora_Fixatge);
                }
            }
        });

        // ── Incidències de la setmana (ara de detallSetmana) ─────────────────
        // CANVI: cp.llistatIncidenciesSetmana -> cp.detallSetmana.llistatIncidencies
        cp?.detallSetmana?.llistatIncidencies?.forEach(e => {
            const start = moment(e.DataInici_IncidenciaFix).format('YYYY-MM-DD');
            const end   = moment(e.DataFi_IncidenciaFix).format('YYYY-MM-DD');

            if (diaAmbFixatges.dia >= start && diaAmbFixatges.dia <= end && e.contahores_Incidencia === '1') {
                if (e.Justificat_IncidenciaFix === '1' &&
                    (tipusDiaLocal === 'Laborable' || (tipusDiaLocal === 'Dissabte' && contingut.jornadaDissabte === 1))) {

                    if ([1, 4, 12].includes(Number(e.IdTipusIncidencia_IncidenciaFix))) {
                        segonsTotalDia += numeroSegonsEntreDates(e.DataInici_IncidenciaFix, e.DataFi_IncidenciaFix);
                    } else {
                        segonsTotalDia += Math.min(
                            (hores / 5) * 60 * 60 * 1000,
                            numeroSegonsEntreDates(e.DataInici_IncidenciaFix, e.DataFi_IncidenciaFix)
                        );
                    }
                }
            }
        });

        // ── Borsa d'hores ────────────────────────────────────────────────────
        contingut?.llistatDiesBorsaHores?.diesBorsa.forEach(e => {
            if (e.dataBorsa === diaAmbFixatges.dia && e.estat === '1') {
                segonsTotalDia += e.minutsDemanats * 60 * 1000;
            }
        });

        return {
            horesTreballades: convertirMilisHores(segonsTotalDia),
            minutsTreballats: convertirMilisMinuts(segonsTotalDia),
            diaAvui: diaAvuiLocal,
            diaAmbIncidencia: diaAmbIncidenciaLocal,
            tipusDia: tipusDiaLocal
        };
    }, [diaAmbFixatges, configUsuari, cp?.detallSetmana?.llistatIncidencies, hores, contadorJornadaIniciada]);

    const handleClick = (dia) => {
        dispatch(uiMostraDiaConsultatAction({ dia }));
        if (incidencia) {
            dispatch(uiAmagarIncidenciesAction());
            dispatch(esborrarErrorAction());
        }
    };

    let descTipusAlertaFixatge = 'DiaComplet';
    if (diaAmbFixatges.dia === moment().format('YYYY-MM-DD')) descTipusAlertaFixatge = 'DiaAvui';
    else if (!diaAmbFixatges.esLaborable) descTipusAlertaFixatge = 'CapSetmana';
    else if ([3, 4].includes(diaAmbFixatges.idTipusAlerta) && diaAmbFixatges.dia < moment().format('YYYY-MM-DD')) descTipusAlertaFixatge = 'Incidencia';
    else if (diaAmbFixatges.idTipusAlerta === 1) descTipusAlertaFixatge = 'DiaFestiu';
    else if (diaAmbFixatges.idTipusAlerta === 2) descTipusAlertaFixatge = 'Vacances';

    return (
        <tr className={descTipusAlertaFixatge}>
            <td>
                <a className='underline' onClick={() => handleClick(diaAmbFixatges.dia)}>
                    <Moment format="DD/MM/YYYY" date={diaAmbFixatges.dia} />
                </a>
            </td>
            <td className={`hores ${diaAmbIncidencia ? 'incidenciaDia' : ''} ${diaAvui ? 'diaAvui' : ''}`}>
                {horesTreballades} {t('Generics.hores')} {t('Generics.caracIoY')} {minutsTreballats} {t('Generics.minuts')}
            </td>
        </tr>
    );
};

export default React.memo(ContadorJornadaHoresSetmana);